var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBioApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87499 8H7.12499L8.15782 10.735C8.34307 11.2256 7.98057 11.75 7.45618 11.75H4.54458C4.02027 11.75 3.65777 11.2258 3.84287 10.7352L4.87499 8ZM5.62499 9.5L5.24999 10.25H6.74999L6.37499 9.5H5.62499Z",
    fill: "#744A0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24999 16.25L5.24999 13.25H6.74999V16.25H5.24999Z",
    fill: "#744A0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87404 14.7881L7.62597 12.916L8.87404 12.084L10.1221 13.9561L8.87404 14.7881Z",
    fill: "#744A0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87789 13.9561L3.12597 12.084L4.37404 12.916L3.12597 14.7881L1.87789 13.9561Z",
    fill: "#744A0B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.891987 1.68659C0.536658 1.19027 0.89141 0.5 1.50181 0.5H10.498C11.1084 0.5 11.4631 1.19025 11.1078 1.68658L7.12499 7.25H4.87499L0.891987 1.68659ZM2.95726 2L5.63583 5.75H6.3639L9.04247 2H2.95726Z",
    fill: "#744A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioApplication);
export default __webpack_public_path__ + "static/media/bioApplication.664f5be2c0a280edf3d4fb4f8c658c32.svg";
export { ForwardRef as ReactComponent };